export default __webpack_public_path__ + "static/media/reversed_green_arrow.7bdf3012.png";